import { render } from "./GetHeroSocialLinks.vue?vue&type=template&id=4c9ea16e&scoped=true"
import script from "./GetHeroSocialLinks.vue?vue&type=script&lang=js"
export * from "./GetHeroSocialLinks.vue?vue&type=script&lang=js"

import "./GetHeroSocialLinks.vue?vue&type=style&index=0&id=4c9ea16e&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c9ea16e"],['__file',"src/scripts/view/portfolio/common/hero/GetHeroSocialLinks.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4c9ea16e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4c9ea16e', __exports__)) {
    api.reload('4c9ea16e', __exports__)
  }
  
  module.hot.accept("./GetHeroSocialLinks.vue?vue&type=template&id=4c9ea16e&scoped=true", () => {
    api.rerender('4c9ea16e', render)
  })

}


export default __exports__